import React, { useState, useCallback } from 'react'
import PopoverConfirm from '@/components/popover-confirm/popover-confirm'
import { getBEMCls } from '@/utils/classname'
import { Row } from '@/components/layout/layout'

import './input-popover.scss'
import { INPUT_NUMBER_LIMIT_REGEXP, WithInputLimit } from '@/utils'

interface InputPopoverProps {
    placeholder?: string
    onConfirm: (e: string) => void
    onValidate?: (e: string) => string
    value?: string
    des?: string
    autoFocus?: boolean
    reg?: RegExp
}

const InputPopover: React.FC<InputPopoverProps> = props => {
    const [val, setRemark] = useState<string>(() => props.value || '')
    const cls = (...arg: string[]) => getBEMCls('input-popover', ...arg)
    const [visable, setVisable] = useState<boolean>(false)
    const [error, setError] = useState<string>('')

    const hidden = useCallback(() => {
        setVisable(false)
    }, [])

    return (
        <PopoverConfirm
            placement="topRight"
            trigger="click"
            visible={visable}
            disabled={!!error || !val}
            onVisibleChange={visible => {
                setVisable(visible)
            }}
            onCancel={hidden}
            content={
                <Row className={cls()} data-position-relative>
                    <div className={cls('des')}>{props.des}</div>
                    {WithInputLimit(
                        <input
                            autoFocus={props.autoFocus}
                            className={cls('text')}
                            placeholder={props.placeholder}
                            onChange={e => {
                                const val = e.target.value
                                if (props.onValidate) {
                                    console.info(props.onValidate(val))
                                    setError(props.onValidate(val))
                                }
                                setRemark(e.target.value)
                            }}
                            value={val}
                        />,
                        props.reg || INPUT_NUMBER_LIMIT_REGEXP,
                    )}
                    <div className={cls('error')}>{error}</div>
                </Row>
            }
            onConfirm={() => {
                hidden()
                props.onConfirm(val)
            }}
        >
            {props.children}
        </PopoverConfirm>
    )
}

InputPopover.defaultProps = {
    placeholder: '请输入',
    autoFocus: true,
}

export default InputPopover
